<section *ngIf="!isbitlyResponse">
  <div id="overlay" class="text-center">
    <div>
      <img src="assets/images/loader_03_v1.gif">
    </div>
  </div>
</section>

<div class="form-page-wrapper">
  <!-- Body -->
  <div class="container-fluid form-page-placement login-page">
    <div class="row margin-top-m50">
      <div class="main-container mb-5 pb-5" *ngIf="isbitlyResponse">
        <div class="form-page-wrapper">
          <div class="container form-page">
            <div class="row clearfix">
              <div class="col-lg-6 col-lg-push-3 col-md-8 col-md-push-2 col-sm-10 col-sm-push-1 col-xs-12 tablet-block container-padding">
                <!-- <div class="template-header-box">
                  <img class="mr-2" src="assets/images/almost_done.svg" width="33" height="31" alt="Bajaj Finserv Direct">
                  <div><span class="tab-header-regular"><span class="pb-2 txt-underline">Yo</span>u are </span><span
                      class="tab-header-heavy">Almost Done!</span></div>
                </div> -->
                <!--- New Emandate Design Start -->
                <div class="card-body px-3">
                  <div class="card-body mb-3">
                    <div class="mandateContainer">
                      <div class="mandate-head">
                        <div class="mandate-logo">
                          <!-- <img *ngIf="emandateStatusRes==''" src="assets/images/emandate.svg">
                              <img *ngIf="emandateStatusRes=='Failure'" src="assets/images/failureEmandate.svg">
                              <img *ngIf="emandateStatusRes=='Success'" src="assets/images/successEmandate.svg"> -->
                          <img [src]="logoImage">
                        </div>
                        <h2 class="text-center" *ngIf="isFailure">E-mandate Submission Failed</h2>
                        <p class="text-danger text-center" *ngIf="failedError">Your bank details are not matching</p>
                        <h2 class="text-center" *ngIf="isSuccess">E-mandate Submitted Successfully</h2>
                      </div>
                      <!-- <div class="mandate-tip text-center" *ngIf="isSuccess">
                        <h4>You are few moments away from completing the process</h4>
                      </div> -->
                      <!-- <img class="ml-auto cursor m-1" src="assets/images/help_icon_blue.svg" width="17" *ngIf="!taskDetails?.emandateDone" data-toggle="modal" data-target="#emandatehelp">
                          <img class="ml-auto" src="assets/images/green_tick.svg" width="25" *ngIf="taskDetails?.emandateDone"> -->
                      <!-- *ngIf="!taskDetails?.emandateDone" -->
                      <!-- <div>
                        <button class="d-block emandate-btn mx-auto my-4 cta-btn col-6"
                          (click)="redirectToApp()">{{isFailure ? 'TRY AGAIN' : 'GO TO Application'}}</button>
                      </div> -->
                      <!-- <div class="or-section text-center" *ngIf="!isSuccess">
                        <label>
                          <span>OR</span>
                        </label>
                        <a class="skip-link">Skip</a>
                        <div class="or-note" *ngIf="!isFailure">
                          <label class="lbl">Tip:</label>
                          <label>If you skip eMandate then you have to fill offline mandate form.</label>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <!-- <div class="d-flex float-right py-4">
                    <button class="box-circle mr-2" ><i class="icon-back_arrow"></i></button>
                    <button class="box-circle mr-2" [disabled]="!isSuccess"><i
                        class="icon-next_arrow"></i></button>
                  </div> -->
                </div>
                <!--- New Emandate Design End -->
              </div>
              
            </div>
            </div>
        </div>
          
        </div>
    </div>
    
  </div>
</div>

